import logo0 from 'common/assets/image/customers/ptc.svg';
import logo1 from 'common/assets/image/customers/reckitt.svg';
import logo2 from 'common/assets/image/customers/allianz-polska.svg';
import logo3 from 'common/assets/image/customers/here-technologies.svg';
import logo4 from 'common/assets/image/customers/logitech.svg';
import logo5 from 'common/assets/image/customers/posthog.svg';
import logo6 from 'common/assets/image/customers/thoughtworks.svg';
import logo7 from 'common/assets/image/customers/toptal.webp';
import logo8 from 'common/assets/image/customers/university-of-michigan.svg';
import logo9 from 'common/assets/image/customers/transition-technologies-psc.svg';
import logo10 from 'common/assets/image/customers/uol.webp';
import logo11 from 'common/assets/image/customers/droptica.svg';
import logo12 from 'common/assets/image/customers/emnify.svg';
import logo13 from 'common/assets/image/customers/the-software-house.svg';
import logo14 from 'common/assets/image/customers/bloomreach.svg';
import logo15 from 'common/assets/image/customers/carfax-europe.svg';
import logo17 from 'common/assets/image/customers/forcepoint.svg';
import logo19 from 'common/assets/image/customers/luxoft.svg';
import logo20 from 'common/assets/image/customers/spark-new-zealand.svg';
import logo21 from 'common/assets/image/customers/tidio.svg';
import logo23 from 'common/assets/image/customers/varo-bank.svg';
import logo24 from 'common/assets/image/customers/wallbox.svg';
import logo25 from 'common/assets/image/customers/xing.svg';

// Order matters: rows 1 and 2 keep this order. Items without `src` are shown as text.
// `scale` is an optical height correction relative to the base logo height.
const customers = [
  {
    name: 'PTC',
    row: 1,
    src: logo0,
    ratio: 2.762,
    scale: 1.2,
  },
  {
    name: 'Reckitt',
    row: 1,
    src: logo1,
    ratio: 1.913,
    scale: 1.25,
  },
  {
    name: 'Allianz Polska',
    row: 1,
    src: logo2,
    ratio: 4.032,
    scale: 1,
  },
  {
    name: 'HERE Technologies',
    row: 1,
    src: logo3,
    ratio: 1,
    scale: 1.55,
  },
  {
    name: 'Logitech',
    row: 1,
    src: logo4,
    ratio: 3.429,
    scale: 1.08,
  },
  {
    name: 'PostHog',
    row: 1,
    src: logo5,
    ratio: 5.714,
    scale: 0.84,
  },
  {
    name: 'Thoughtworks',
    row: 1,
    src: logo6,
    ratio: 6.242,
    scale: 0.8,
  },
  {
    name: 'Toptal',
    row: 1,
    src: logo7,
    ratio: 3.522,
    scale: 1.07,
  },
  {
    name: 'University of Michigan',
    row: 1,
    src: logo8,
    ratio: 5.028,
    scale: 0.89,
  },
  {
    name: 'Transition Technologies PSC',
    row: 1,
    src: logo9,
    ratio: 4.383,
    scale: 0.96,
  },
  {
    name: 'UOL (uol.pl)',
    row: 1,
    src: logo10,
    ratio: 2.768,
    scale: 1.2,
    label: 'uol.pl',
  },
  {
    name: 'Droptica',
    row: 1,
    src: logo11,
    ratio: 3.919,
    scale: 1.01,
  },
  {
    name: 'emnify',
    row: 1,
    src: logo12,
    ratio: 1.206,
    scale: 1.25,
  },
  {
    name: 'The Software House',
    row: 2,
    src: logo13,
    ratio: 2.213,
    scale: 1.25,
  },
  {
    name: 'Bloomreach',
    row: 2,
    src: logo14,
    ratio: 7.413,
    scale: 0.73,
  },
  {
    name: 'CARFAX Europe',
    plain: true,
    row: 2,
    src: logo15,
    ratio: 5.464,
    scale: 0.72,
  },
  {
    name: 'Eurocash',
    row: 2,
  },
  {
    name: 'Forcepoint',
    row: 2,
    src: logo17,
    ratio: 5.143,
    scale: 0.88,
  },
  {
    name: 'iFood',
    row: 2,
  },
  {
    name: 'Luxoft',
    row: 2,
    src: logo19,
    ratio: 12.942,
    scale: 0.56,
  },
  {
    name: 'Spark New Zealand',
    row: 2,
    src: logo20,
    ratio: 2.721,
    scale: 1.21,
  },
  {
    name: 'Tidio',
    row: 2,
    src: logo21,
    ratio: 2.941,
    scale: 1.17,
  },
  {
    name: 'Uniwersytet WSB Merito',
    row: 2,
  },
  {
    name: 'Varo Bank',
    row: 2,
    src: logo23,
    ratio: 2.719,
    scale: 0.85,
  },
  {
    name: 'Wallbox',
    row: 2,
    src: logo24,
    ratio: 4.216,
    scale: 0.97,
  },
  {
    name: 'XING',
    row: 2,
    src: logo25,
    ratio: 3.419,
    scale: 1.08,
  },
];

export default customers;
